<template>
  <router-view />
</template>

<script >
import http from "@/plugins/axios";
import {th} from "vuetify/locale";
import router from "@/router";
export default {
  name: 'logout',

  data: () => ({
  }),
  methods:{

    checkLogin(){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/logout/", { headers: { Authorization: AuthStr } })
          .then(response => {
          })
          .catch((error) => {

          });
      localStorage.removeItem("token");
      router.push("/login");
    }
  },
  mounted() {
    this.checkLogin();
  },
}
</script>



<style scoped>
.fill-height{
  width: 100%;
  max-width: 100%;
}
v-sheet{
  background: transparent;
}
  .form-group{
    margin: 10px auto;
    width: 100%;
  }
  .form-group input{
    padding: 10px;
    width: 100%;
  }
.form-group .label{
  margin: 10px 0;
}
button.btn{
  width: 400px;
  max-width: 90%;
  padding: 10px;
  margin: 10px auto;
}
  .back{
    background-color: #e8e8e8;
    background-image: url('../assets/newback1.png');
    background-repeat: repeat;
    background-size: cover;
  }
  #login{
    background: transparent;
  }
  #login .form-inputs {
    padding-bottom: 10px;
  }

  #login .form-inputs label {
    padding-right: 10px;
  }
  .loading{
    position: absolute;
    top: 65%;
    left: 49%;
  }
  .mx-auto{
    direction: rtl;
    background: transparent;
  }
  .v-field--center-affix .v-label.v-field-label{
    right: 0;
  }
  .noneshow{
    opacity: 0;
  }
  #login h3{
    margin: 20px auto;
  }
  .login{
    max-width: 100%;
    width: 500px;
    padding: 0 10px;
  }
.rowlogin {
  width: 100%;
}
</style>